import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { PublicLayout } from "@/components/news/PublicLayout";
import DeskLayout, { RoleGate } from "@/components/desk/DeskLayout";
import Home from "@/pages/Home";
import ListingPage from "@/pages/ListingPage";
import StoryPage from "@/pages/StoryPage";
import StaticPage from "@/pages/StaticPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ReporterSignupPage from "@/pages/ReporterSignupPage";
import Dashboard from "@/pages/desk/Dashboard";
import StoriesPage from "@/pages/desk/StoriesPage";
import StoryEditor from "@/pages/desk/StoryEditor";
import StoryReview from "@/pages/desk/StoryReview";
import ReportersPage from "@/pages/desk/ReportersPage";
import UsersPage from "@/pages/desk/UsersPage";
import TaxonomyPage from "@/pages/desk/TaxonomyPage";
import CommentsPage from "@/pages/desk/CommentsPage";
import AuditPage from "@/pages/desk/AuditPage";
import SettingsPage from "@/pages/desk/SettingsPage";

const gate = (roles, el) => <RoleGate roles={roles}>{el}</RoleGate>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/category/:slug" element={<ListingPage mode="category" />} />
                <Route path="/trend/:type" element={<ListingPage mode="trend" />} />
                <Route path="/story/:slug" element={<StoryPage />} />
                <Route path="/page/:key" element={<StaticPage />} />
              </Route>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/reporter/apply" element={<ReporterSignupPage />} />
              <Route path="/desk" element={<DeskLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="stories" element={<StoriesPage />} />
                <Route path="stories/new" element={gate(["editor", "reporter"], <StoryEditor />)} />
                <Route path="stories/:id" element={<StoryReview />} />
                <Route path="stories/:id/edit" element={<StoryEditor />} />
                <Route path="queue" element={gate(["news_approver"], <StoriesPage queue />)} />
                <Route path="reporters" element={gate(["reporter_approver"], <ReportersPage />)} />
                <Route path="users" element={gate([], <UsersPage />)} />
                <Route path="taxonomy" element={gate(["editor"], <TaxonomyPage />)} />
                <Route path="comments" element={gate(["editor", "news_approver"], <CommentsPage />)} />
                <Route path="audit" element={gate(["reporter_approver", "news_approver"], <AuditPage />)} />
                <Route path="settings" element={gate([], <SettingsPage />)} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
